import { API_URL, PRICE_SCHEME_HEADER } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import { IPatchPriceBandBody, IPatchPriceBandResponse, IPriceBandResponse } from './types';

export const updatePriceBand = async (
  priceBandId: string,
  priceSchemeId: string,
  requestBody: IPatchPriceBandBody,
): Promise<IPatchPriceBandResponse> => {
  try {
    const response = await fetch(`${API_URL}/pricing/price-bands/${priceBandId}`, {
      method: 'PATCH',
      body: JSON.stringify(requestBody),
      headers: {
        'Content-Type': 'application/json',
        [PRICE_SCHEME_HEADER]: priceSchemeId,
      },
    });

    if (!response.ok) {
      throw new Error();
    }

    const { data }: IPriceBandResponse = await response.json();
    return data;
  } catch (e) {
    throw new Error('Something went wrong whilst updating price band.');
  }
};
